package com.lightningkite.kiteui

object ViewWrapper